"use client"

import { SettingsSection } from "./settings-section"
import { SettingsToggle } from "./settings-toggle"
import { Button } from "../button"
import { Shield } from "lucide-react"

export function PrivacyControls() {
  return (
    <SettingsSection title="Privacy Controls" icon={Shield}>
      <div className="flex items-center justify-between p-4 rounded-lg bg-slate-50">
        <div className="flex flex-col">
          <p className="text-base font-bold text-slate-900">Share Progress with Friends</p>
          <p className="text-sm font-normal text-slate-600">Let friends see your achievements.</p>
        </div>
        <SettingsToggle id="toggle-share" defaultChecked={true} />
      </div>
      <div className="flex items-center justify-between p-4 rounded-lg bg-slate-50">
        <div className="flex flex-col">
          <p className="text-base font-bold text-slate-900">Privacy & Safety Guide</p>
          <p className="text-sm font-normal text-slate-600">Learn how we keep you safe.</p>
        </div>
        <Button className="bg-teal-600 text-white border-teal-600 hover:bg-teal-700 hover-text-white">
          Read Guide
        </Button>
      </div>
    </SettingsSection>
  )
}
